module.exports = __webpack_public_path__ + "img/title_no.999d4a40.svg";